import React from 'react';
import AtributosInfo from '../../Components/Admin/AtributosInfo/AtributosInfo';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const AtributosInfoPage = () => {
  const { rol } = useSelector((state) => state.auth);

  if (rol !== 'admin') return <Navigate to="/" />;

  return <AtributosInfo />;
};

export default AtributosInfoPage;
